module.exports = __webpack_public_path__ + "statics/img/4-7.0ccfdcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-7.png
// module id = bwS1
// module chunks = 1